import { render, staticRenderFns } from "./ArchiveOrdersModal.vue?vue&type=template&id=f0a7e790&"
import script from "./ArchiveOrdersModal.vue?vue&type=script&lang=js&"
export * from "./ArchiveOrdersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ArchiveOrdersModal.vue"
export default component.exports